import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=2195be08&scoped=true&"
import script from "./ProductHeader.vue?vue&type=script&lang=js&"
export * from "./ProductHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=2195be08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195be08",
  null
  
)

export default component.exports